export const colors = {
  primary: {
    main: '#007595',
    dark: '#013E51',
    light: '#BFF2FE',
  },
  text: {
    primary: '#101828',
    secondary: '#6A7282',
    inverse: '#F9FAFB',
    body: 'rgba(0, 0, 0, 0.87)',
  },
  border: {
    header: '#99A1AF',
    card: '#D0D0D0',
    footer: '#D1D5DC',
    button: '#013E51',
  },
  background: {
    page: '#F5F8FA',
    surface: '#F5F7FA',
    footer: '#F4FDFF',
    hoverRow: '#EDF9FC',
  },
  gradient: {
    banner: 'linear-gradient(180deg, #DFF7FE 0%, #FFFFFF 100%)',
  },
} as const;

export const layout = {
  headerHeight: 72,
  bannerHeight: 145,
  iconSize: 50,
  iconRadius: 8,
  cardRadius: 16,
  versionRowHeight: 44,
  versionDotSize: 8,
} as const;
